var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-amap-marker"},[_c('div',{ref:"content",staticClass:"v-amap-marker-content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }